import { WDHGeoIpPrompt } from '../../../../wdh-feature/wdh-geo-ip-prompt';
var geoIpPrompt = new WDHGeoIpPrompt();
geoIpPrompt.goToCountrySubPage = true;
geoIpPrompt.run();